export interface UserConfig {
  keepFacetsOnSearchStringChange: boolean;
  expandAllFacetsDefault: boolean;
}

export const userConfig: UserConfig = {
  keepFacetsOnSearchStringChange: false,
  expandAllFacetsDefault: false,
};
